import { Button, DatePicker, Form, Input, Modal, Select } from "antd";
import axios from "axios";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { getAllWorkPlace } from "../../../redux/rtk/features/masters/workPlaceSlice";
import { getCompanyOfficeMaster, loadSingleStaff } from "../../../redux/rtk/features/user/userSlice";
import { updateWorkPlaceHistory } from "../../workPlaceHistory/workPlaceHistoryApis";
import BtnEditSvg from "../Button/btnEditSvg";

const WorkPlaceEditSinglePopup = ({ data, setLoading }) => {
    console.log("Incoming Data:", data);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [companyNames, setCompanyNames] = useState([]);
    const { Option } = Select;

    const dispatch = useDispatch();
    const user_id = useParams("id");

    const workPlace = useSelector((state) => state.workPlace.list);
    const officeName = useSelector((state) => state.users?.officeName);
    console.log("Office Name:", officeName);

    const [loader, setLoader] = useState(false);
    const [workPlaceId, setWorkPlaceId] = useState("");
    const [comment, setworkPlaceComment] = useState("");

    const [startDate, setWorkPlaceStartDate] = useState(null);
    const [endDate, setWorkPlaceEndDate] = useState(null);

    // Fetch workplaces and office master data on mount
    useEffect(() => {
        dispatch(getAllWorkPlace());
        dispatch(getCompanyOfficeMaster());
    }, [dispatch]);

    // Fetch company names
    useEffect(() => {
        const fetchCompanyNames = async () => {
            setLoader(true);
            try {
                const response = await axios.get("setting/getCompanySetting");
                if (response?.data?.length) {
                    const names = response.data.map((setting) => setting.company_name);
                    setCompanyNames(names);
                }
            } catch (error) {
                console.error("Error fetching company names:", error);
            } finally {
                setLoader(false);
            }
        };
        fetchCompanyNames();
    }, []);

    // Update state when data changes
    useEffect(() => {
        if (data) {
            setWorkPlaceId(data?.workPlaceId || "");
            setWorkPlaceStartDate(data?.startDate ? dayjs(data.startDate).format("YYYY-MM-DD") : null);
            setWorkPlaceEndDate(data?.endDate ? dayjs(data.endDate).format("YYYY-MM-DD") : null);
            setworkPlaceComment(data?.comment || "");
        }
    }, [data]);

    const onFinish = async (values) => {
        setLoading(true);
        setLoader(true);

        const payload = {
            workPlaceId: workPlaceId || values.workPlaceId,
            startDate: startDate ? dayjs(startDate).toISOString() : null,
            endDate: endDate ? dayjs(endDate).toISOString() : null,
            comment: comment || values.comment || "",
        };

        console.log("Payload for update:", payload);

        try {
            const resp = await updateWorkPlaceHistory(data.id, payload);
            if (resp.message === "success") {
                dispatch(loadSingleStaff(user_id.id));
                resetForm();
                setIsModalOpen(false);
            } else {
                toast.error("Failed to update workplace history.");
            }
        } catch (error) {
            console.error("Update failed:", error);
            toast.error("An error occurred while updating workplace history.");
        } finally {
            setLoader(false);
            setLoading(false);
        }
    };

    const resetForm = () => {
        setWorkPlaceId("");
        setworkPlaceComment("");
        setWorkPlaceStartDate(null);
        setWorkPlaceEndDate(null);
    };

    const showModal = () => {
        setIsModalOpen(true);
    };

    const handleOk = () => {
        resetForm();
        setIsModalOpen(false);
    };

    const handleCancel = () => {
        resetForm();
        setIsModalOpen(false);
    };

    return (
        <>
            <button onClick={showModal} className="mr-2">
                <BtnEditSvg size={20} />
            </button>
            <Modal
                title={`Edit Work place`}
                open={isModalOpen}
                onOk={handleOk}
                onCancel={handleCancel}
            >
                <Form
                    style={{ marginBottom: "100px" }}
                    initialValues={{
                        workPlaceId: workPlaceId,
                        startDate: startDate ? dayjs(startDate) : null,
                        endDate: endDate ? dayjs(endDate) : null,
                        comment: comment,
                    }}
                    onFinish={onFinish}
                    autoComplete="off"
                >
                    <Form.Item
                        name="workPlaceId"
                        label="Work place"
                        rules={[{ required: true, message: "Please select a work place!" }]}
                    >
                        <Select
                            placeholder="Select work place"
                            showSearch
                            allowClear
                            value={workPlaceId}
                            onChange={(value) => setWorkPlaceId(value)}
                        >
                            {workPlace.map((place) => (
                                <Option key={place.id} value={place.id}>
                                    {place.workplace}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Form.Item
                        label="Start Date"
                        name="startDate"
                        rules={[{ required: true, message: "Please input start date!" }]}
                    >
                        <DatePicker
                            format="YYYY-MM-DD"
                            value={startDate ? dayjs(startDate, "YYYY-MM-DD") : null}
                            onChange={(date) => setWorkPlaceStartDate(date ? date.format("YYYY-MM-DD") : null)}
                        />
                    </Form.Item>

                    <Form.Item label="End Date" name="endDate">
                        <DatePicker
                            format="YYYY-MM-DD"
                            value={endDate ? dayjs(endDate) : null}
                            onChange={(date) => setWorkPlaceEndDate(date ? date.format("YYYY-MM-DD") : null)}
                        />
                    </Form.Item>

                    <Form.Item label="Comment" name="comment">
                        <Input
                            value={comment}
                            onChange={(e) => setworkPlaceComment(e.target.value)}
                        />
                    </Form.Item>

                    <Form.Item wrapperCol={{ offset: 6, span: 12 }}>
                        <Button
                            loading={loader}
                            type="primary"
                            htmlType="submit"
                        >
                            Update
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
};

export default WorkPlaceEditSinglePopup;
